"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        active: true,
        id: 1,
        locationId: 0,
        name: 'Trunkrs B.V.',
    },
];
